import { Box, IconButton } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

const INDENT_PX = 24;

const TreeTableCellContent = ({
  column,
  node,
  index,
  depth,
  hasChildren,
  isExpanded,
  onToggleExpand,
  renderActions,
}) => {
  const handleToggle = (e) => {
    e.stopPropagation();
    onToggleExpand(node.id);
  };

  if (index === 0) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          pl: `${depth * INDENT_PX}px`,
        }}>
        <IconButton
          size='small'
          onClick={hasChildren ? handleToggle : undefined}
          sx={{
            mr: 0.5,
            p: 0.25,
            visibility: hasChildren ? 'visible' : 'hidden',
          }}>
          {isExpanded ? (
            <KeyboardArrowDownIcon fontSize='small' />
          ) : (
            <KeyboardArrowRightIcon fontSize='small' />
          )}
        </IconButton>
        <Box sx={{ fontWeight: hasChildren ? 500 : 400 }}>
          {column.render
            ? column.render(node[column.key], node)
            : node[column.key]}
        </Box>
      </Box>
    );
  }

  if (column.key === 'actions' && renderActions) {
    return renderActions(node);
  }

  return column.render
    ? column.render(node[column.key], node)
    : node[column.key];
};

export default TreeTableCellContent;
